import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { BottomScrollListener } from './BottomScrollListener';

const ListViewRowWrapper = ({
  rows,
  numberOfColumns,
  loading,
  onBottomScroll,
}) => {
  const content = (
    <Fragment>
      {rows}
      {(loading || rows.length === 0) && (
        <tr>
          <td colSpan={numberOfColumns}>
            {loading && (
              <span>
                Loading... <i className="fa fa-spin fa-spinner" />
              </span>
            )}
            {!loading && rows.length === 0 && <span>No data found</span>}
          </td>
        </tr>
      )}
    </Fragment>
  );

  if (onBottomScroll !== undefined) {
    return (
      <BottomScrollListener onBottom={onBottomScroll}>
        {content}
      </BottomScrollListener>
    );
  } else {
    return content;
  }
};

ListViewRowWrapper.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.node).isRequired,
  numberOfColumns: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  onBottomScroll: PropTypes.func,
};

export { ListViewRowWrapper };
